import Device from "../../../devices/device";
import {DOWN, UP} from "../../RibbonNew/constants";

function setScrollDown(indexRibbon, ribbonsIds) {
  const focusedIndex = ribbonsIds[indexRibbon + 1]

  const ribbonEl = document.getElementById(focusedIndex);
  if (!ribbonEl) return;

  const HEADER_HEIGHT = 92;
  const rect = ribbonEl.getBoundingClientRect();
  const viewHeight = window.innerHeight - HEADER_HEIGHT;


  if (rect.top < HEADER_HEIGHT || rect.bottom > viewHeight) {
    ribbonEl.scrollIntoView(false);
  }
}

function setScrollUp(indexRibbon, ribbonsIds) {
  const focusedIndex = ribbonsIds[indexRibbon - 1]

  const ribbonEl = document.getElementById(focusedIndex);
  if (!ribbonEl) return;

  const parentElement = ribbonEl.parentElement.parentElement;
  if (!parentElement) return;

  const HEADER_HEIGHT = 92;
  const rect = ribbonEl.getBoundingClientRect();
  const viewHeight = window.innerHeight - HEADER_HEIGHT;


  if (rect.top < HEADER_HEIGHT || rect.bottom > viewHeight) {
    parentElement.scrollIntoView(true);
  }
};

/**
 * Asegurar que el ribbon enfocado sea completamente visible en pantalla.
 * Solo desplaza si el ribbon está parcial o totalmente fuera del viewport.
 */
export function scrollToRibbon(ribbonId, ribbonsIds, direction) {
  const isEnabled = Device.getDevice().getPlatform() === 'ps4'
  if (!isEnabled || !ribbonId || !ribbonsIds ) return;

  const indexRibbon = ribbonsIds.indexOf(ribbonId)
  direction === DOWN && setScrollDown(indexRibbon, ribbonsIds);
  direction === UP && setScrollUp(indexRibbon, ribbonsIds);

}



// WEBPACK FOOTER //
// ./src/components/RibbonGridNew/PS4/PS4RibbonScrolling.js